import { defineComponent as _defineComponent } from 'vue'
import { User } from '@/models/User';
import { computed } from 'vue';
import { useRoute } from 'vue-router/composables';
import MainSidebar from '@/components/layout/sidebars/MainSidebar/MainSidebar.vue';
import WorkspacesSidebar from '@/components/layout/sidebars/WorkspacesSidebar/WorkspacesSidebar.vue';
import CommentsSidebar from '@/components/layout/sidebars/CommentsSidebar.vue';
import NotificationsSidebar from '@/components/layout/sidebars/NotificationsSidebar/NotificationsSidebar.vue';
import TranscriptionSidebar from '@/components/layout/sidebars/TranscriptionSidebar/TranscriptionSidebar.vue';
import ArticleVersionsSidebar from '@/components/layout/sidebars/ArticleVersionsSidebar.vue';
import * as routerNames from '@/routerNames';
import authService from '@/services/AuthService';
import store from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'SidebarManager',
  setup(__props) {

const route = useRoute();

const user = computed((): User => store.state.user);
const isCompanyPaid = computed(() => store.state.company.isPaid);
const isSuperAdmin = computed(() => user.value.isSuperAdmin());

const isEditPage = computed((): boolean => {
  const currentRoute = route.name;

  return (
    currentRoute === routerNames.ARTICLE_EDIT ||
    currentRoute === routerNames.ARTICLE_CREATE ||
    currentRoute === routerNames.DRAFT_EDIT ||
    currentRoute === routerNames.ARTICLE_VERSION_EDIT
  );
});

const isCommentsSidebarVisible = computed((): boolean => store.state.commentsSidebar.isVisible);

const isArticleVersionsSidebar = computed((): boolean => store.state.ui.isArticleVersionsSidebar);

const isUserInactiveInCompany = computed((): boolean => store.state.isUserInactiveInCompany);

const isAuthorized = computed(() => store.state.user && authService.isAuthorized());

const isAuthPage = computed((): boolean => {
  const currentRoute = route.name;

  return (
    currentRoute === routerNames.SIGNUP ||
    currentRoute === routerNames.SIGNUP_INVITED ||
    currentRoute === routerNames.LOGIN_SOCIAL_CALLBACK ||
    currentRoute === routerNames.LOGIN_SOCIAL_FAIL ||
    currentRoute === routerNames.LOGIN_SOCIAL_TWO_FACTOR ||
    currentRoute === routerNames.LOGIN ||
    currentRoute === routerNames.PASSWORD_RESET ||
    currentRoute === routerNames.PASSWORD_RESET_TOKEN ||
    currentRoute === routerNames.ACCOUNT_RECOVERY_REDEEM ||
    currentRoute === routerNames.ACCOUNT_RECOVERY_CANCEL
  );
});

return { __sfc: true,route, user, isCompanyPaid, isSuperAdmin, isEditPage, isCommentsSidebarVisible, isArticleVersionsSidebar, isUserInactiveInCompany, isAuthorized, isAuthPage, MainSidebar, WorkspacesSidebar, CommentsSidebar, NotificationsSidebar, TranscriptionSidebar, ArticleVersionsSidebar }
}

})